import { ICourseInstanceReducer } from '../Interfaces/ICourseInstanceReducer';
import { IAction } from '../../../__core/Interfaces/IAction';
import { IApiJsonResponse } from '../../../__core/Interfaces/IApiResponse';
import { ICourseInstance } from '../../../__core/Interfaces/ICourseInstance';
import { IEvent } from '../../../__core/Interfaces/IEvent';
import { courseInstanceInitState } from './CourseInstanceInitState';
import { courseInstanceDetailsReducer } from './CourseInstanceDetails';
import { ICourse } from '../../../__core/Interfaces/ICourse';
import { instanceReducer } from './Instance';
import { instanceAccessForLecturesReducer } from './InstanceAccessForLectures';
import { instanceAccessForStudentsReducer } from './InstanceAccessForStudents';
import { InstanceAccessResponse } from '../Types/InstanceAccessResponse';
import { lecturerAccessForModulesReducer } from './LecturerAccessForModules';
import {
  gradebookReducer,
  GradebookReducerAction,
} from '../Components/Gradebook/Reducers/Gradebook';
import {
  SharingLoadersAction,
  sharingLoadersReducer,
} from '../Components/Sharing/Reducers/SharingLoaders';

type CourseInstanceReducerAction =
  | IAction<IApiJsonResponse<ICourseInstance>>
  | IAction<IApiJsonResponse<ICourse>>
  | IAction<InstanceAccessResponse>
  | IAction<IApiJsonResponse<Array<number>>>
  | GradebookReducerAction
  | IEvent;

export const courseInstanceReducer = (
  state: ICourseInstanceReducer = courseInstanceInitState,
  action: CourseInstanceReducerAction
): ICourseInstanceReducer => {
  return {
    details: courseInstanceDetailsReducer(
      state.details,
      action as IAction<IApiJsonResponse<ICourse>>
    ),
    instance: instanceReducer(
      state.instance,
      action as IAction<IApiJsonResponse<ICourseInstance>>
    ),
    instanceAccessForStudents: instanceAccessForStudentsReducer(
      state.instanceAccessForStudents,
      action as IAction<InstanceAccessResponse>
    ),
    instanceAccessForLectures: instanceAccessForLecturesReducer(
      state.instanceAccessForLectures,
      action as IAction<InstanceAccessResponse>
    ),
    lecturerAccessForModules: lecturerAccessForModulesReducer(
      state.lecturerAccessForModules,
      action as IAction<IApiJsonResponse<Array<number>>>
    ),
    gradebook: gradebookReducer(
      state.gradebook,
      action as GradebookReducerAction
    ),
    sharingLoaders: sharingLoadersReducer(
      state.sharingLoaders,
      action as SharingLoadersAction
    ),
  };
};
